import React, { useState } from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Navigation from "./components/Navigation";
import CostCalculator from "./components/CostCalculator";
import WarmUpPage from "./components/WarmUpPage";

function App() {
  const [activeTab, setActiveTab] = useState("calculator");

  const renderContent = () => {
    switch (activeTab) {
      case "calculator":
        return <CostCalculator />;
      case "warmup":
        return <WarmUpPage />;
      default:
        return <CostCalculator />;
    }
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Navigation activeTab={activeTab} onTabChange={setActiveTab} />
        {renderContent()}
      </BrowserRouter>
    </div>
  );
}

export default App;